/** @format */
import { css } from 'styled-components';

import { largeTablet, smallTablet } from '@toucan/client/global/application';
import { theme } from '@toucan/client/global/theme';

/* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
export const styles = css`
    display: grid;
    grid-template-columns: 18rem minmax(0, 1fr);
    gap: var(--layout-spacing-24);
    align-items: start;

    .timeline-detail-thumbnail {
        background-color: var(--colors-surface-secondary);
        border-radius: var(--effects-radius-sm);
        overflow: hidden;

        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }

    .timeline-detail-body {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: var(--layout-spacing-8);
        min-width: 0;
    }

    .timeline-detail-name {
        color: var(--colors-text-secondary);
        overflow-wrap: anywhere;
    }

    /*
     * One flowing sentence, with the percentages in it picked out larger and in
     * the brand colour. Inline rather than laid out, so a model that sits in both
     * hands reads as a single sentence with both shares in it and wraps like
     * prose.
     */
    /*
     * Typography comes from the Heading this is rendered as, so only the colour is
     * set here.
     */
    .timeline-detail-share {
        color: var(--colors-text-primary);
    }

    /*
     * Nothing but the colour: the percentage is part of the sentence around it, so
     * it inherits that sentence's size and weight and is picked out in pink alone.
     * Both percentages in the both-sides case come through here, so they match each
     * other as well as the words between them.
     */
    .timeline-detail-share-value {
        color: var(--colors-brand-secondary);
    }

    .timeline-detail-text {
        ${theme.typography.body_small}
        color: var(--colors-text-primary);
    }

    .timeline-detail-link {
        margin-top: var(--layout-spacing-8);
    }

    // At this width there is not enough room for the image beside the copy,
    // so the card drops to a single column and the thumbnail is capped to
    // stop it growing to fill the whole width.
    ${largeTablet(css`
        grid-template-columns: minmax(0, 1fr);
        gap: var(--layout-spacing-16);

        .timeline-detail-thumbnail {
            max-width: 24rem;
        }
    `)}

    /*
     * Narrow enough that the image and the model's name sit side by side rather
     * than the name being pushed under a full width image, which left the card
     * reading as a picture with a caption a long way below it.
     *
     * The name is the only part of the body that comes up beside the image; the
     * share, the description and the link stay in a column underneath both. That
     * needs all four to be items of this same grid, which is what display: contents
     * on the body does — it takes the body out of the layout without taking its
     * children out of the DOM. Desktop is untouched: the body stays an ordinary
     * flex column up there.
     */
    ${smallTablet(css`
        grid-template-columns: auto minmax(0, 1fr);
        column-gap: var(--layout-spacing-16);
        row-gap: var(--layout-spacing-8);

        .timeline-detail-thumbnail {
            max-width: 12rem;
            grid-column: 1;
            grid-row: 1;
        }

        .timeline-detail-body {
            display: contents;
        }

        .timeline-detail-name {
            grid-column: 2;
            grid-row: 1;
            /* Centred against the image beside it rather than sat on its top edge. */
            align-self: center;
            text-align: left;
        }

        .timeline-detail-share,
        .timeline-detail-text,
        .timeline-detail-link {
            grid-column: 1 / -1;
        }
    `)}
`;
/* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
